var twig = require("twig").twig,
    tokens = [{"type":"raw","value":"<input (input) type=\"text\">"}],
    template = twig({"id":"$resolved:2300d78f176c6649b9d691b127ed9223c2c2bc94d372fe3639cefff8515c30b70e2226e0b301eb8d4b0f3b09ba047996a05acbd866a282672c1e06e273cf86c2:magic-input-float.twig","data":[{"type":"raw","value":"<input (input) type=\"text\">"}],"allowInlineIncludes":true,"rethrow":true});

module.exports = function(context) { return template.render(context); }

module.exports.tokens = tokens;